var EditableListItem = React.createClass({
  propTypes: {
    showDelete: React.PropTypes.bool,
    showEdit: React.PropTypes.bool,
    onDelete: React.PropTypes.func,
    onEdit: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      showEdit: false,
      showDelete: false
    };
  },
  getInitialState() {
    return {
      isConfirmVisible: false
    };
  },
  componentWillReceiveProps(nextProps) {
    if (!nextProps.showDelete) {
      this.setState({isConfirmVisible: false});
    }
  },
  hasControls() {
    return this.props.showEdit || this.props.showDelete;
  },
  showConfirmDelete() {
    this.setState({isConfirmVisible: true});
  },
  hideConfirmDelete() {
    this.setState({isConfirmVisible: false});
  },
  deleteConfirmClicked(confirmed) {
    this.setState({isConfirmVisible: false});

    let {onDelete} = this.props;

    if (confirmed && onDelete) {
      onDelete();
    }
  },
  editClicked() {
    this.props.onEdit();
  },
  renderConfirm() {
    return (
      <div className="edit-item__controls">
        <div className="btn-group">
          <button
           type="button"
           className="btn btn-danger btn-xs"
		   aria-label={`${Labels.getLabel("Delete")}`} title={`${Labels.getLabel("Delete")}`}
           onClick={this.deleteConfirmClicked.bind(this, true)}>
           <i className="glyphicon glyphicon-trash"></i>
           {` ${Labels.getLabel("Delete")}`}
         </button>
          <button
            type="button"
            className="btn btn-default btn-xs"
            onClick={this.hideConfirmDelete}>
            <i className="fa fa-ban"></i>
          </button>
        </div>
      </div>
    );
  },
  renderControls() {
    if (this.state.isConfirmVisible) {
      return this.renderConfirm();
    }

    let {
      showEdit,
      showDelete,
    } = this.props;

    let deleteButton = showDelete ?
      <button
        type="button"
        className="btn btn-danger btn-xs"
		aria-label={`${Labels.getLabel("Delete")}`} title={`${Labels.getLabel("Delete")}`}
        onClick={this.showConfirmDelete}>
        <i className="glyphicon glyphicon-trash"></i>
      </button> : null;

    let editButton = showEdit ?
      <button
        type="button"
        className="btn btn-default btn-xs"
		aria-label={`${Labels.getLabel("Edit")}`} title={` ${Labels.getLabel("Edit")}`}
        onClick={this.editClicked}>
        <i className="glyphicon glyphicon-pencil"></i>
      </button> : null;

    return (
      <div className="edit-item__controls">
        <div className="btn-group">{editButton}{deleteButton}</div>
      </div>
    );
  },
  render() {
    let hasControls = this.hasControls();
    let content = hasControls ?
        <div className="edit-item__content">{this.props.children}</div> : this.props.children;

    return (
      <li className={classNames({"edit-item": hasControls, clearfix: hasControls})} >
        {hasControls ? this.renderControls() : null}
        {content}
      </li>
    )
  }
})
